var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBody = function SvgBody(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.73 21C31.3868 21 32.73 19.6569 32.73 18C32.73 16.3431 31.3868 15 29.73 15C28.0731 15 26.73 16.3431 26.73 18C26.73 19.6569 28.0731 21 29.73 21Z",
    fill: "#2D3336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.565 24.165C34.98 23.58 33.975 22.5 32.025 22.5C31.71 22.5 29.895 22.5 28.215 22.5C24.09 22.485 20.73 19.125 20.73 15H17.73C17.73 19.74 20.895 23.76 25.23 25.065V45H28.23V36H31.23V45H34.23V27.075L40.155 33L42.27 30.885L35.565 24.165Z",
    fill: "#2D3336"
  })));
};
export default SvgBody;